import { apiRequest } from './client';
import type { Provider, ProviderPreferences, ProviderStaffProfile, ProviderUser } from '@/types';

export const getMe = () =>
    apiRequest<{ provider: Provider; providerUser: ProviderUser }>('/account/me');

export const updateBusiness = (updates: Partial<Provider>) =>
    apiRequest<{ provider: Provider }, Partial<Provider>>('/account/business', {
        method: 'PATCH',
        body: updates,
    });

/**
 * Manda solo los campos que cambiaron: el backend hace merge con lo guardado,
 * así que no hace falta reenviar el objeto completo.
 */
export const updatePreferences = (updates: ProviderPreferences) =>
    apiRequest<{ provider: Provider }, ProviderPreferences>('/account/preferences', {
        method: 'PATCH',
        body: updates,
    });

export const updateProfile = (
    updates: { firstName?: string; lastName?: string; staffProfile?: ProviderStaffProfile },
) =>
    apiRequest<{ providerUser: ProviderUser }>('/account/profile', {
        method: 'PATCH',
        body: updates,
    });

export const changePassword = (currentPassword: string, newPassword: string) =>
    apiRequest<{ success: boolean; message: string }>('/account/password', {
        method: 'PATCH',
        body: { currentPassword, newPassword },
    });

export const deleteAccount = () =>
    apiRequest<{ success: boolean }>('/account', { method: 'DELETE' });

/*
 * Imagen de perfil y logo. La respuesta trae la URL **ya firmada**, así que se
 * puede pintar sin releer `/account/me`.
 */
const imageForm = (file: File) => {
    const form = new FormData();
    form.append('photo', file);
    return form;
};

export const uploadAvatar = (file: File) =>
    apiRequest<{ avatarUrl: string }>('/account/profile/avatar', {
        method: 'POST',
        body: imageForm(file),
        formData: true,
    });

export const deleteAvatar = () =>
    apiRequest<{ success: boolean }>('/account/profile/avatar', { method: 'DELETE' });

export const uploadLogo = (file: File) =>
    apiRequest<{ logoUrl: string }>('/account/business/logo', {
        method: 'POST',
        body: imageForm(file),
        formData: true,
    });

export const deleteLogo = () =>
    apiRequest<{ success: boolean }>('/account/business/logo', { method: 'DELETE' });
